import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Box,
} from '@material-ui/core';
import { Typography } from '../../../components/Wrappers/Wrappers.jsx';
import TableContainer from '../../../commons/ECALTable/TableContainer';
import Dialog from '../../../commons/dialog/Dialog';
import Widget from '../../../components/Widget/Widget.jsx';

import { useStyles } from './styles';

import { useHistory } from 'react-router';

import {
  columns,
  customCells,
  options,
} from './tableSettings';

import {
  useOptinsStore,
} from '../../../store/models';
function OptinsList (props) {
    const {
        optinsData,
        onAdd,
        showProgress,
    } = props;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(false);
    const classes = useStyles();

    const optinsStore = useOptinsStore();

    useEffect(() => {
      setLoading(showProgress);
    }, [showProgress]);

    return (
    <React.Fragment>
      <Grid item xs={12}>
        <Widget className={classes.widgetContainer}
            title="Manage Opt-ins"
            inheritHeight
            disableWidgetMenu
            handleAdd={onAdd}
            intercomTitleTarget={'manage-optins-title'}
            >
            <Box
                justifyContent={'space-between'}
                display={'flex'}
                alignItems={'flex-start'}
            >
                <Typography variant='body2'>
                  Your opt-ins appear on your displays, and allow users to accept your privacy policy and terms, and consent to receive additional marketing from you.
                </Typography>
            </Box>
        </Widget>

        <TableContainer
              classes={classes}
              tableData={optinsData}
              columns={columns}
              customCells={customCells}
              tableTitle='Opt-ins'
              moduleType='opt-ins'
              showProgress={loading}
              options={options}
              rowsPerPage={optinsData.length}
              onEdit={(data) => {
                optinsStore.optinsForEdit = data;
                optinsStore.saveOptinsForEdits();
                history.push('/admin/marketing/optins/edit/' + data.id);
              }}

              onDelete={(data) => {
                console.log('Data: ', data);
                setDeleteTarget(data);
                setDeleteOpen(true);
              }}
            />

      </Grid>

      <Dialog
        openDialog={deleteOpen}
        handleAgree={() => {
          setDeleteOpen(false);
          optinsStore.deleteOptins({ ...deleteTarget });
        }}

        closeModal={() => {
          setDeleteOpen(false);
        }}
        title={'Delete opt-in'}
        dialogContextText={'Are you sure you want to delete this opt-in?'}
      />
    </React.Fragment>
  );
}

OptinsList.propTypes = {
    optinsData: PropTypes.array,
    onAdd: PropTypes.func,
    showProgress: PropTypes.bool,
};

OptinsList.default = {
    optinsData: [],
    onAdd: () => {},
    showProgress: true,
};

export default OptinsList;
